module.exports = __webpack_public_path__ + "static/media/nuotata.ed44e564.jpeg";